import type { CSSProperties } from 'react';

const CAMINHO_ROTA = 'M40,66 C 92,124 36,196 112,228 C 176,254 148,300 192,330';
const LARGURA_MAPA = 240;
const ALTURA_MAPA = 380;

const estiloMotoboy: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  fontSize: '22px',
  filter: 'drop-shadow(0 2px 3px rgba(0,0,0,0.35))',
};
(estiloMotoboy as Record<string, string>).offsetPath = `path("${CAMINHO_ROTA}")`;

export function TelefoneMapaRota() {
  return (
    <div
      style={{
        width: '270px',
        margin: '0 auto',
        background: '#111',
        borderRadius: '38px',
        padding: '12px',
        boxShadow: '0 24px 48px rgba(16,32,61,0.28)',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '12px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '90px',
          height: '18px',
          background: '#111',
          borderRadius: '0 0 14px 14px',
          zIndex: 3,
        }}
      />
      <div
        style={{
          width: '100%',
          background: '#dbe6f2',
          borderRadius: '28px',
          overflow: 'hidden',
        }}
      >
        {/* Barra de status */}
        <div
          style={{
            background: 'var(--cor-primaria)',
            color: '#fff',
            fontSize: '11px',
            fontWeight: 600,
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 18px 8px',
          }}
        >
          <span>9:41</span>
          <span>📶 🔋</span>
        </div>
        <div
          style={{
            background: 'var(--cor-primaria)',
            color: '#fff',
            fontSize: '13px',
            fontWeight: 700,
            padding: '0 16px 12px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          🧭 Rota calculada automaticamente
        </div>

        {/* Mapa */}
        <div
          style={{
            position: 'relative',
            width: `${LARGURA_MAPA}px`,
            height: `${ALTURA_MAPA}px`,
            margin: '0 auto',
            background:
              'repeating-linear-gradient(0deg, #cfe0f0 0px, #cfe0f0 1px, transparent 1px, transparent 38px), repeating-linear-gradient(90deg, #cfe0f0 0px, #cfe0f0 1px, transparent 1px, transparent 38px), #e7eff8',
          }}
        >
          <svg
            width={LARGURA_MAPA}
            height={ALTURA_MAPA}
            viewBox={`0 0 ${LARGURA_MAPA} ${ALTURA_MAPA}`}
            style={{ position: 'absolute', top: 0, left: 0 }}
          >
            <path
              d={CAMINHO_ROTA}
              fill="none"
              stroke="#1845ba"
              strokeWidth={5}
              strokeLinecap="round"
              strokeDasharray="2 12"
              opacity={0.85}
            />
          </svg>

          {/* Marcador de origem */}
          <div
            className="lizzi-pino-pulsante"
            style={{
              position: 'absolute',
              top: '66px',
              left: '40px',
              transform: 'translate(-50%, -100%)',
              width: '30px',
              height: '30px',
              borderRadius: '50% 50% 50% 0',
              background: 'var(--cor-gradiente)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 3px 6px rgba(0,0,0,0.25)',
            }}
          >
            <span style={{ fontSize: '14px' }}>🍽️</span>
          </div>

          {/* Marcador de destino */}
          <div
            style={{
              position: 'absolute',
              top: '330px',
              left: '192px',
              transform: 'translate(-50%, -100%)',
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              background: '#fff',
              border: '3px solid var(--cor-erro)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 3px 6px rgba(0,0,0,0.25)',
            }}
          >
            <span style={{ fontSize: '14px' }}>📍</span>
          </div>

          {/* Motoboy animado percorrendo a rota */}
          <div className="lizzi-motoboy-animado" style={estiloMotoboy}>
            🛵
          </div>

          {/* Cartão de informações estilo Waze */}
          <div
            style={{
              position: 'absolute',
              left: '12px',
              right: '12px',
              bottom: '12px',
              background: '#fff',
              borderRadius: '14px',
              padding: '10px 14px',
              boxShadow: '0 6px 16px rgba(16,32,61,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <div style={{ fontSize: '15px', fontWeight: 800, color: 'var(--cor-texto)' }}>3,2 km</div>
              <div style={{ fontSize: '11px', color: 'var(--cor-texto)' }}>9 min até o cliente</div>
            </div>
            <span
              style={{
                fontSize: '11px',
                fontWeight: 700,
                color: '#fff',
                background: 'var(--cor-sucesso)',
                borderRadius: '999px',
                padding: '4px 10px',
              }}
            >
              A caminho
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
